<template>
  <div class="follow m-r-4 m-l-4">
    <Popover placement="bottom" trigger="click" @visibleChange="visibleChange">
      <template #content>
        <div class="pop-content">
          <div class="m-b-12 title">绑定公众号</div>
          <Alert
            message="管理员和专员绑定公众号后，公众号将推送专员订单1分钟未处理的超时通知"
            type="warning"
            show-icon
          />
          <div v-if="loading" class="p-t-24 m-t-24">加载中...</div>
          <div v-else class="scan-code">
            <div class="scan-img center p-t-12 p-b-12">
              <img :src="imgUrl" alt="公众号加载失败,请稍后再试！" />
            </div>
          </div>
        </div>
      </template>

      <!-- <span> 关注大黄鹅</span> -->
      <i
        style="font-size: 22px"
        class="iconfont icon-weixin1 text-secondary"
      ></i>
    </Popover>
  </div>
</template>
<script lang="ts" setup>
import { ref } from 'vue';
import { Popover, Alert } from 'ant-design-vue';
import { getOfficialAccountApi } from '/@/api/common/index';
import { useUserStoreWithOut } from '/@/store/modules/user';

const userStore = useUserStoreWithOut();

const imgUrl = ref('');
const loading = ref<boolean>(false);
const loadQRcode = async () => {
  try {
    loading.value = true;
    const userId = 'G@' + userStore.getUserInfo.userId;
    const {
      data: { content },
    } = await getOfficialAccountApi({
      userId,
    });

    loading.value = false;
    imgUrl.value = content.image;
  } catch (error) {
    loading.value = false;
    console.log('error==>', error);
  }
};
const visibleChange = (v: boolean) => {
  !v ? (imgUrl.value = '') : loadQRcode();
};
</script>
<style scoped lang="less">
.follow {
  cursor: pointer;

  // position: absolute;
  > span {
    color: #666;
  }
}
.pop-content {
  text-align: center;
  .title {
    text-align: left;
  }
  height: 400px;
  width: 300px;
  .scan-code {
    padding: 0 6px;
    width: 100%;
    // height: 100%;
    > div {
      img {
        width: 100%;
        height: 100%;
      }
    }
    > span {
      font-size: 16px;
      color: #666;
    }
  }
}
</style>
